<svelte:options customElement={{ tag: "bt-checkbox", shadow: "none", }} />

<script lang="ts">
	import { createEventDispatcher } from "svelte";

	export let isChecked: boolean = false;
	export let label: string = '';
	export let design: 'fill' | 'checkmark' = 'fill';

	const dispatch = createEventDispatcher();

	const handleChange = () => {
		dispatch('checkbox-changed', {
			label: label,
			isChecked: isChecked
		});
	}
</script>

 <label class={`checkbox checkbox--${design}`}>
  <input type="checkbox" bind:checked={isChecked} on:change={handleChange} />
  <span>{label}</span>
 </label>

<style>
  .checkbox {
    display: flex;
    align-items: center;
    height: theme('spacing.6');
    margin-top: theme('spacing.2');
    font-size: theme('fontSize.sm');
    span {
      display: inline-block;
      margin-left: theme('spacing.1');
      &:hover {
        cursor: pointer;
      }
    }
    input[type="checkbox"] {
      -webkit-appearance: none;
      appearance: none;
      background-color: transparent;
      margin: 0;
      font: inherit;
      color: currentColor;
      width: theme('spacing.4');
      height: theme('spacing.4');
      border: theme('borderWidth.2') solid currentColor;
      display: grid;
      place-content: center;
      &:hover {
        cursor: pointer;
      }

      &:focus {
        outline: 1px solid theme('colors.sky-blue');
        outline-offset: 1px;
      }
    }
  }
  .checkbox--fill input[type="checkbox"] {
		&:before {
	    content: '';
	    width: theme('spacing.2');
	    height: theme('spacing.2');
	    transform: scale(0);
	    transition: 100ms transform ease-in-out;
	    box-shadow: inset theme('spacing.4') theme('spacing.4') theme('colors.sky-blue');
	    /* Windows High Contrast Mode */
	    background-color: CanvasText;
	  }
	  &:hover::before {
	    transform: scale(.5);
	  }

	  &:checked::before {
	    transform: scale(1);
	  }
	}
	.checkbox--checkmark input[type="checkbox"] {
		position: relative;
		background: white;
		border-color: transparent;
		&:before {
	    content: '';
	    width: theme('spacing.2');
	    height: theme('spacing.2');
	 		background-color: transparent;
	    width: .5rem;
	    height: 1rem;
	    border-bottom: .25rem solid theme('colors.neutral.900');
	    border-right: .25rem solid theme('colors.neutral.900');
	    transform: scale(0) rotate(45deg);
	  }
	  &:focus {
	    box-shadow: inset -1px -1px theme('colors.neutral.300'), 
	    						inset 1px 1px theme('colors.neutral.300');
	  }
    &:hover {
      outline: 1px solid theme('colors.sky-blue');
      outline-offset: 1px;
    }
	  &:checked::before {
	  	transform: scale(.6) rotate(45deg);
	  }
	}
</style>